class InternalTicketService {
    axiosInstance;
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    adminPortal = {
        subscription: {
            // TODO: handle query params
            query: (query) => {
                return this.axiosInstance.socket.connect('/internal-ticket/admin-portal/internal-ticket', {
                    params: query,
                });
            },
            workflow: {
                query: () => {
                    return this.axiosInstance.socket.connect('/internal-ticket/admin-portal/workflow', {
                        keepAliveOnBlur: true,
                    });
                },
                sendMessage: async (data, query) => {
                    return this.axiosInstance.socket.sendMessage('/internal-ticket/admin-portal/workflow', data, {
                        params: query,
                        keepAliveOnBlur: true,
                    });
                },
            },
        },
        fetch: async (id) => {
            const response = await this.axiosInstance.mainInstance.get(`/internal-ticket/admin-portal/internal-ticket/${id}`);
            return response.data;
        },
        query: async (query) => {
            const response = await this.axiosInstance.mainInstance.get(`/internal-ticket/admin-portal/internal-ticket`, { params: query });
            return response.data;
        },
        create: async (input) => {
            const response = await this.axiosInstance.mainInstance.post('/internal-ticket/admin-portal/internal-ticket', input);
            return response.data;
        },
        update: async (internalTicketID, input) => {
            const response = await this.axiosInstance.mainInstance.patch(`/internal-ticket/admin-portal/internal-ticket/${internalTicketID}`, input);
            return response.data;
        },
        delete: async (internalTicketID) => {
            const response = await this.axiosInstance.mainInstance.delete(`/internal-ticket/admin-portal/internal-ticket/${internalTicketID}`);
            return response.data;
        },
        tag: {
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/internal-ticket/admin-portal/tag/${id}`);
                return response.data;
            },
            query: async (query) => {
                const response = await this.axiosInstance.mainInstance.get(`/internal-ticket/admin-portal/tag`, { params: query });
                return response.data;
            },
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/internal-ticket/admin-portal/tag', input);
                return response.data;
            },
            update: async (tagID, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/internal-ticket/admin-portal/tag/${tagID}`, input);
                return response.data;
            },
            delete: async (tagID) => {
                const response = await this.axiosInstance.mainInstance.delete(`/internal-ticket/admin-portal/tag/${tagID}`);
                return response.data;
            },
        },
    };
    customerPortal = {
        query: async (query) => {
            const response = await this.axiosInstance.mainInstance.get(`/internal-ticket/customer-portal/internal-ticket`, { params: query });
            return response.data;
        },
        create: async (input) => {
            const response = await this.axiosInstance.mainInstance.post('/internal-ticket/customer-portal/internal-ticket', input);
            return response.data;
        },
    };
    wayste = {
        subscription: {
            query: (query) => {
                return this.axiosInstance.socket.connect('/internal-ticket/wayste/internal-ticket', {
                    params: query,
                });
            },
            workflow: {
                query: () => {
                    return this.axiosInstance.socket.connect('/internal-ticket/wayste/workflow', {
                        keepAliveOnBlur: true,
                    });
                },
                sendMessage: async (data, query) => {
                    return this.axiosInstance.socket.sendMessage('/internal-ticket/wayste/workflow', data, {
                        params: query,
                        keepAliveOnBlur: true,
                    });
                },
            },
        },
        fetch: async (id) => {
            const response = await this.axiosInstance.mainInstance.get(`/internal-ticket/wayste/internal-ticket/${id}`);
            return response.data;
        },
        query: async (query) => {
            const response = await this.axiosInstance.mainInstance.get(`/internal-ticket/wayste/internal-ticket`, { params: query });
            return response.data;
        },
        create: async (input) => {
            const response = await this.axiosInstance.mainInstance.post('/internal-ticket/wayste/internal-ticket', input);
            return response.data;
        },
        update: async (internalTicketID, input) => {
            const response = await this.axiosInstance.mainInstance.patch(`/internal-ticket/wayste/internal-ticket/${internalTicketID}`, input);
            return response.data;
        },
        delete: async (internalTicketID) => {
            const response = await this.axiosInstance.mainInstance.delete(`/internal-ticket/wayste/internal-ticket/${internalTicketID}`);
            return response.data;
        },
        tag: {
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/internal-ticket/wayste/tag/${id}`);
                return response.data;
            },
            query: async (query) => {
                const response = await this.axiosInstance.mainInstance.get(`/internal-ticket/wayste/tag`, { params: query });
                return response.data;
            },
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/internal-ticket/wayste/tag', input);
                return response.data;
            },
            update: async (tagID, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/internal-ticket/wayste/tag/${tagID}`, input);
                return response.data;
            },
            delete: async (tagID) => {
                const response = await this.axiosInstance.mainInstance.delete(`/internal-ticket/wayste/tag/${tagID}`);
                return response.data;
            },
        },
    };
}
export default InternalTicketService;
//# sourceMappingURL=InternalTicket.service.js.map